export default __webpack_public_path__ + "static/media/Warning_on.0218a908.svg";